
import Vue from "vue";

import TaxLookup from "../components/TaxLookup.vue";
import LevyMarketValueSearch from "../components/LevyMarketValueSearch.vue";

export default Vue.extend({
	name: "LevyEstimator",

	props: ["disclaimer", "note"],

	data() {
		return {
			isLoading: true,
			activeTab: "tax-lookup" as string,
		};
	},
	components: {
		TaxLookup,
		LevyMarketValueSearch,
	},
});
